import { SystemEvent, SystemEventLevel } from "./system-event.js";
export class Logger {
  event;
  info;
  warning;
  error;
  constructor(logger) {
    this.event = logger.event || (() => {
    });
    const logAtLevel = (level, message, ...args) => {
      if (this.event) {
        this.event(new SystemEvent(level, message), ...args);
      }
    };
    this.info = logger.info || ((message, ...args) => logAtLevel(SystemEventLevel.INFO, message, ...args));
    this.warning = logger.warning || ((message, ...args) => logAtLevel(SystemEventLevel.WARN, message, ...args));
    this.error = logger.error || ((message, ...args) => logAtLevel(SystemEventLevel.ERROR, message, ...args));
  }
}
